import type { SimulatorAppDefinition, SimulatorCommandInput, SimulatorLaunchSource } from "./appManifest.js";

export interface BuildSimulatorCommandRequestInput {
  activeMachine: string;
  app: Pick<SimulatorAppDefinition, "id" | "title" | "launchCapability">;
  commandType?: string;
  capability?: string;
  payload?: Record<string, unknown>;
  profileId: string;
  requestId: string;
  source?: SimulatorLaunchSource;
  ticketId?: string;
}

export interface SimulatorCommandRequest {
  appId: string;
  commandType: string;
  capability: string;
  payload: Record<string, unknown>;
}

export function buildSimulatorCommandRequest(input: BuildSimulatorCommandRequestInput): SimulatorCommandRequest {
  const commandType = input.commandType ?? "OPEN_APP";
  const capability = input.capability ?? input.app.launchCapability ?? "simulator.open";
  const basePayload: Record<string, unknown> = {
    appId: input.app.id,
    title: input.app.title,
    machineId: input.activeMachine,
    profileId: input.profileId,
    requestId: input.requestId
  };

  if (input.source) {
    basePayload.launcher = input.source;
  }

  if (input.ticketId) {
    basePayload.ticketId = input.ticketId;
  }

  return {
    appId: input.app.id,
    commandType,
    capability,
    payload: {
      ...basePayload,
      ...(input.payload ?? {})
    }
  };
}

export function commandInputForLaunch(
  app: Pick<SimulatorAppDefinition, "id" | "title" | "launchCapability">,
  payload: Record<string, unknown> = {}
): SimulatorCommandInput {
  return {
    appId: app.id,
    commandType: "OPEN_APP",
    capability: app.launchCapability ?? "simulator.open",
    payload: {
      appId: app.id,
      title: app.title,
      ...payload
    },
    label: `Open ${app.title}`
  };
}
